import Dexie from 'dexie'
import { FollowUp } from '../../../shared/interfaces/FollowUp.interface'
import { FollowUpDocument } from '../../../shared/interfaces/FollowUpDocument.interface'
import { FormDocument } from '../../../shared/interfaces/FormDocument.interface'
import { BaseFormIndexDatabaseService } from './BaseFormIndexDatabase.service'

class FollowUpIndexDatabaseService extends BaseFormIndexDatabaseService {
  public readonly DOCUMENT_RECORDS_TABLE_NAME = 'followUpDocumentRecords'
  public documentRecords: Dexie.Table<FollowUpDocument, string>
  public db: FollowUpIndexDatabaseService

  constructor() {
    super()
    this.db = this
    this.documentRecords = this.table(this.DOCUMENT_RECORDS_TABLE_NAME)
    this.open()
  }

  public deleteFollowUpDocumentsIfNotMatching = async (
    followUpDocuments: Array<FollowUpDocument>,
    clinicId: number
  ): Promise<void> => {
    await this.deleteFormDocumentsIfNotMatching(followUpDocuments, clinicId)
  }

  protected deleteFormDocumentsIfNotMatching = async (
    formDocuments: Array<FormDocument>,
    clinicId: number
  ): Promise<void> => {
    const localFormDocuments: Array<FormDocument> = await this.db.documentRecords
      .filter((formDocument: FormDocument) => {
        const { lastSuccessfullSync, data } = formDocument.document as FollowUp
        return lastSuccessfullSync && data.followUp.hospital && data.followUp.hospital.enumId === clinicId
      })
      .toArray()
    for (let i = 0; i < localFormDocuments.length; i++) {
      if (
        !formDocuments.find(
          (formDocument: FormDocument) => formDocument.document.uuid === localFormDocuments[i].document.uuid
        )
      ) {
        // eslint-disable-next-line no-await-in-loop
        await this.deleteFormDocument(localFormDocuments[i].document.uuid)
      }
    }
  }

  public filterFollowUpDocumentByStatus = (
    clinicId: number,
    followUpDocument: FollowUpDocument,
    allowedStatuses: Array<string>
  ): boolean => this.filterFormDocumentByStatus(clinicId, followUpDocument, allowedStatuses)

  protected filterFormDocumentByStatus = (
    clinicId: number,
    formDocument: FormDocument,
    allowedStatuses: Array<string>
  ): boolean => {
    const { data, status } = formDocument.document as FollowUp
    const matchesClinic: boolean = data.followUp.hospital && data.followUp.hospital.enumId === clinicId
    return allowedStatuses.includes(status) && matchesClinic
  }
}

const followUpIndexDatabaseService = new FollowUpIndexDatabaseService()
export default followUpIndexDatabaseService
